import { COMPLIANCE_DOCUMENTS_CRUD_ACTION_CREATORS } from '../actions/compliance_documents_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
import { ROLE_TYPES } from '../utils/DataConstants';

const fetchUtils = new FetchUtils();

// Proposed backend contract: /api/v1/supplier/compliance/documents
// Compliance documents are owned by suppliers; buyers only ever see them
// hydrated onto request instances.
const complianceDocumentsRestCrudThunksForSupplier = new RestCrudThunks(
	'documents',
	'compliance_document',
	'complianceDocument',
	'complianceDocuments',
	COMPLIANCE_DOCUMENTS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	true,
	'compliance/'
);

export const complianceDocumentsRestCrudThunks = (userType) =>
	complianceDocumentsRestCrudThunksForSupplier;

// GET /api/v1/supplier/compliance/clients -> [{ id, name }]
// The buyer companies connected to this supplier, for document sharing.
export const fetchComplianceClients =
	(userType) =>
	(targetCollectionName = 'complianceClientsDropdown') => {
		const baseUrl = getBackendUri();
		const apiUrl = `/api/v1/${userType}/compliance/clients`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(COMPLIANCE_DOCUMENTS_CRUD_ACTION_CREATORS.fetchStart(targetCollectionName));
				fetchUtils
					.get(baseUrl + apiUrl, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					})
					.then(parseJSON)
					.then(({ json, status }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
							reject('unauthorized');
							return;
						}
						if (d.status === 'error') {
							dispatch(COMPLIANCE_DOCUMENTS_CRUD_ACTION_CREATORS.fetchError(d.message));
							reject(d.message);
						} else {
							dispatch(
								COMPLIANCE_DOCUMENTS_CRUD_ACTION_CREATORS.fetchSuccess(
									d.data,
									d.count,
									targetCollectionName,
									null,
									null,
									null,
									false
								)
							);
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(COMPLIANCE_DOCUMENTS_CRUD_ACTION_CREATORS.fetchError(d.message));
						reject(d.message);
					});
			});
		};
	};
